export enum AdminSubscriptionListItemAction {
  BillingAddressEdit,
  Cancel,
  More,
  Preview,
  Process,
  Edit,
  Resume,
  ShippingAddressEdit,
  Suspend,
}
